'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _conversationUtil = require('../../utils/conversationUtil');

var _Conversation = require('../../components/Conversation');

var _MessageScrollView = require('../../components/MessageScrollView');

var _MessageScrollView2 = _interopRequireDefault(_MessageScrollView);

var _MessageContainer = require('./MessageContainer');

var _MessageContainer2 = _interopRequireDefault(_MessageContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * Conversation container responsible for displaying
 * a flat list of messages in a.. less flat way.
 */
var ConversationContainer = (0, _mobxReact.observer)(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(ConversationContainer, _React$Component);

  function ConversationContainer() {
    (0, _classCallCheck3.default)(this, ConversationContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ConversationContainer.__proto__ || (0, _getPrototypeOf2.default)(ConversationContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConversationContainer, [{
    key: 'renderMessageGroups',
    value: function renderMessageGroups(messageGroups) {
      var _props = this.props,
          onMarkAsRead = _props.onMarkAsRead,
          otherName = _props.otherName,
          _onDocumentClick = _props.onDocumentClick;

      return messageGroups.map(function (group, i) {
        return _react2.default.createElement(
          _Conversation.MessageGroup,
          { mine: group.mine, key: i },
          group.messages.map(function (message) {
            // `message` is a plain mapped object, not the actual instance,
            // which is added as a property.
            var actualMessage = message.message;
            return _react2.default.createElement(_MessageContainer2.default, (0, _extends3.default)({
              key: actualMessage.id,
              otherName: otherName,
              message: actualMessage,
              seenBy: message.seenBy,
              group: group,
              onDocumentClick: function onDocumentClick() {
                return _onDocumentClick(actualMessage);
              }
            }, !actualMessage.isRead && {
              onEnterViewport: function onEnterViewport() {
                return onMarkAsRead(actualMessage);
              }
            }));
          })
        );
      });
    }

    /**
     * Does the render thing.
     */

  }, {
    key: 'render',
    value: function render() {
      var messageGroups = this.messageGroups;

      return _react2.default.createElement(
        _MessageScrollView2.default,
        {
          onLoadMore: this.props.onLoadMore,
          isLoadingMore: this.props.isLoadingMore,
          messageCount: this.props.messages.length,
          scrollToBottom: unreadMessagesFormatter({ count: this.props.unreadMessagesCount })
        },
        _react2.default.createElement(
          _Conversation.Conversation,
          null,
          messageGroups.length === 0 ? this.props.noMessages || false : this.renderMessageGroups(messageGroups)
        )
      );
    }
  }, {
    key: 'messageGroups',
    get: function get() {
      // We are expecting the messages to be in order.
      var messages = this.props.messages;
      var me = this.props.me;
      return (0, _conversationUtil.createMessageGroups)(messages, me);
    }
  }]);
  return ConversationContainer;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, 'messageGroups', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'messageGroups'), _class2.prototype)), _class2)) || _class;

ConversationContainer.propTypes = {
  messages: _propTypes2.default.any,
  me: _propTypes2.default.any,
  onMarkAsRead: _propTypes2.default.func,
  onLoadMore: _propTypes2.default.func,
  isLoadingMore: _propTypes2.default.bool,
  noMessages: _propTypes2.default.element,
  unreadMessagesCount: _propTypes2.default.number,
  otherName: _propTypes2.default.string,
  onDocumentClick: _propTypes2.default.any
};

exports.default = ConversationContainer;

/**
 * Simple message formatter.
 */

function unreadMessagesFormatter(_ref) {
  var count = _ref.count;

  if (!count) {
    return 'Scroll to bottom';
  }

  if (count === 1) {
    return '1 unread message';
  }

  return count + ' unread messages';
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/containers/ConversationContainer/index.js
// module id = 627
// module chunks = 0